import React from 'react';
import { observer } from 'src/utils/mobx-react';

const parseMinimumOdds = (debugDetails: string): number => {
    // INFO: Just in case if debugDetails is not a string, there is a chance to get an error
    if (typeof debugDetails !== 'string') {
        return 0;
    }

    try {
        // debug value for this error looks like: BetMinOdds [0.333 GTE 1.5]
        const numericValues = debugDetails.match(/-?\d+(\.\d+)?/g);

        return numericValues === null ? 0 : parseFloat(numericValues[1] ?? '0');
    } catch {
        return 0;
    }
};

const getErrorMessage = (error: { field: string; debugDetails: string; code: string }): JSX.Element => {
    switch (error.field) {
        case 'potentialReturn': {
            const debugDetails = error.debugDetails;

            const minOdds = parseMinimumOdds(debugDetails);

            return <li>Minimum Odds on free bets are {minOdds}</li>;
        }
        case 'selectedFreeBets':
            return <li>Lower your stake if you want to use your bet credits.</li>;
        case 'bets[].freeBets':
            return <li>Added free bets can&apos;t cover all bets total stakes</li>;
        default:
            return <span>{error.code}</span>;
    }
};

const getBonusEngineFreeBetErrors = (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    errors: any
): Array<{
    resource: string;
    debugDetails: string;
    field: string;
    code: string;
}> => {
    const seen = new Set();

    return errors
        .filter((error: { resource: string | string[] }) => error.resource.includes('bonus-engine'))
        .filter((el: { debugDetails: unknown }) => {
            const duplicate = seen.has(el.debugDetails);

            seen.add(el.debugDetails);

            return !duplicate;
        });
};

export const BonusEngineFreeBetErrorMessages = observer(
    'BonusEngineFreeBetErrorMessages',
    ({ errors }: { errors: unknown }) => {
        const bonusEngineFreeBetErrors = getBonusEngineFreeBetErrors(errors);

        if (bonusEngineFreeBetErrors.length === 0) {
            return null;
        }

        const firstError = bonusEngineFreeBetErrors[0];

        if (firstError === undefined) {
            return null;
        }

        return <ul className='betslip-errors'>{bonusEngineFreeBetErrors.map(getErrorMessage)}</ul>;
    }
);
